import { render, staticRenderFns } from "./PedidoImpressao.vue?vue&type=template&id=f7a370bc&scoped=true"
import script from "./PedidoImpressao.vue?vue&type=script&lang=js"
export * from "./PedidoImpressao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a370bc",
  null
  
)

export default component.exports